import React from "react";
import { getIndustryKey } from "../../constants/uiRegistry";
import RouteBoard from "./dispatch/RouteBoard";
import EventsCalendar from "./EventsCalendar";
import "./SchedulePlaceholders.css";

const DISPATCH_INDUSTRIES = new Set(["pest_control", "landscaping", "general", "default"]);
const CALENDAR_INDUSTRIES = new Set(["events"]);

function ScheduleComingSoon({ industry }) {
  return (
    <div className="schedule-placeholder" style={{ padding: "40px 24px" }}>
      <div className="schedule-card" style={{ maxWidth: 520, textAlign: "center", margin: "60px auto" }}>
        <h2 style={{ margin: "0 0 12px", fontSize: 20 }}>Schedule</h2>
        <p className="schedule-muted" style={{ fontSize: 14, lineHeight: 1.6 }}>
          A scheduling view for this industry is coming soon.
        </p>
        <p className="schedule-muted" style={{ marginTop: 16 }}>
          Use the Pipeline board to track bookings and lead progress.
        </p>
      </div>
    </div>
  );
}

export default function RoutePlanner() {
  const industry = getIndustryKey("general");

  if (CALENDAR_INDUSTRIES.has(industry)) {
    return <EventsCalendar />;
  }

  if (DISPATCH_INDUSTRIES.has(industry)) {
    return <RouteBoard />;
  }

  return <ScheduleComingSoon industry={industry} />;
}
